export const figure18 = {
chart: {
type: 'line',
backgroundColor: 'rgba(255, 255, 255, 0.0)',
height: 230,
plotBackgroundColor: null,
plotBorderWidth: null,
},
credits: {
enabled: false
},
title: {
text: 'Malawi'
},
subtitle: {
text: null
},
xAxis: {
categories: ['2011','2013','2017', '2020']
},
labels: {
format: '{value}',
style: {
fontWeight: 'normal',
color: '#999999',
fontSize: '12px'
},
},
yAxis: {
min: 0,
max: 10,
tickInterval: 2,
title: {
text: null,
},
},
plotOptions: {
series: {
marker: {
	 enabled: false,
	 states: {
			  hover: {
					 enabled: false
				 }
		  }
 }
},		 
line: {

dataLabels: {
enabled: false
},
enableMouseTracking: true
}

},
legend: {
enabled: false,
},

colors: ['#5a99d3', '#f5b493','#a5a5a5', '#fdc201'],
series: [{
name: 'Pequeños productores',
data: [4.27, 6.4, 4.0, 2.0],
pointStyle: false,
}, {
name: 'Productores no pequeños',
data: [7.32, 8.6, 5.4, 2.3],
pointStyle: false,	    
},{
name: 'Unidades de pequeños productores dirigidas por mujeres',
data: [4.02, 6.12, 3.8, 1.8],
pointStyle: false,
},{
name: 'Unidades de pequeños productores dirigidas por hombres',
data: [4.38, 6.46, 4.1, 2.1],
pointStyle: false,
}]
}

